import React, { FC, useMemo, useState, useEffect } from 'react'
import { useDispatch, useSelector } from '../../../store'
import CustomPopup from '../../UI/Popup'
import Checkbox from '../../UI/Inputs/Checkbox'
import CustomButton from '../../UI/Buttons/CustomButton'
import { APPROVAL_TYPE, POST_SOCIAL_STATUS, POST_STATUS } from '../../../models/post'
import './HashtagListModal.scss'
import { toggleHashtagListModal } from '../../../store/hashtag/slice'
import { getHashtagThunk } from '../../../store/hashtag/thunks'
import { Hashtag } from '../../../store/hashtag/types'

interface HashtagListModalInterface { }

const HashtagListModal: FC<HashtagListModalInterface> = () => {
    const dispatch = useDispatch()
    const [ selectedHashtag, setSelectedHashtag] = useState<Array<number>>([]);
    // const [ copiedTag, setCopiedtag] = useState<Array<number>>([]);
    const {
        project,
        isHashtagListModalOpen,
        hashtags
    } = useSelector((state) => ({
        project: state.project.currentProject,
        isHashtagListModalOpen: state.hashtag.isHashtagListModalOpen,
        hashtags: state.hashtag.hashtags,
        inProgress: state.hashtag.inProgress,
    }))

    useEffect(() => {
        let projectID=project.id;
        const currentProjectId:any = window.location.pathname.split('/')[1];
        if(currentProjectId !=project.id){
            projectID=currentProjectId;
        }
        const getHashtags = () => {
            dispatch(getHashtagThunk(projectID))
        }
        getHashtags()
    }, [project.id])

    const close = () => {
        dispatch(toggleHashtagListModal())
    }

    const onCopy = (data:Hashtag)=>{
        const hastag = [...selectedHashtag]
        const index = hastag.findIndex(v=>v === data.id);
        if(index > -1){
            hastag.splice(index,1);
        }else{
            hastag.push(data.id)
        }
        let hashtagClipboard = ''
         hastag.forEach((v)=>{
             const tags = hashtags.find(h=>h.id === v);
             if(tags){
                hashtagClipboard += ` ${tags.hashtags}`;
             }
         })
        navigator.clipboard.writeText(hashtagClipboard.trim())
        setSelectedHashtag(hastag)
    }

    return (
        <>
            <CustomPopup
                open={isHashtagListModalOpen}
                buttonClose={() => close()}
                closeOnDocumentClick={false}
                className='hashtag-list-modal'
            >
                <div className='hashtag-list-modal__wrapper'>
                    <div className='hashtag-list-modal__title'>Hashtag Pools</div>
                    <p className='hashtag-list-modal__subtext'>Copy one of your pools to your clipboard</p>
                    <div className='hashtag-list-modal__list'>
                        {hashtags.map((v:Hashtag, k) => (<div className='hashtag-list-modal__input'>
                            <div className='hashtag-list-modal__checklist'>
                                <div className='checkbox-input__label'> {v.pool_name}</div>
                                <div>
                                    <CustomButton button='primary' type='submit' className={selectedHashtag.includes(v.id)?'active':''} onClick={()=>onCopy(v)}>{selectedHashtag.includes(v.id)?'Copied':'Copy'}</CustomButton>
                                </div>
                            </div>
                        </div>))}
                    </div>
                </div>
            </CustomPopup>
        </>
    )
}

export default HashtagListModal
